var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CImportFromJotformView',{attrs:{"is-marketing-importer":true},on:{"close":_vm.onClosed}})
}
var staticRenderFns = []

export { render, staticRenderFns }